
import bildEinfamilienhaus from '@/assets/icons/gebaeudetyp_einzelhaus.svg';
import bildMehrfamilienhaus from '@/assets/icons/gebaeudetyp_mehrfamilienhaus.svg';
import bildReihenmittelhaus from '@/assets/icons/gebaeudetyp_reihenmittelhaus.svg';

export const buildingTypes = [
    { name: 'Ein- oder Zweifamilienhaus', available: true, value: 'einfamilienhaus', api: '22453', image: bildEinfamilienhaus },
    { name: 'Reihenmittel- oder Endhaus', available: true, value: 'reihenmittelhaus', api: '22454', image: bildReihenmittelhaus },
    { name: 'Mehrfamilienhaus', available: false,  value: 'mehrfamilienhaus', api: '22455', image: bildMehrfamilienhaus },
];

export const buildingTypesApi = {parameter: '19367', type: 'value_choice'}

